<template>
  <div id="lossDeletionPage">
    <!-- Collapsible Standard Filter Card -->
    <vs-row id="globalFilter" vs-type="flex" vs-w="12" class="bg-white p-4 mb-4 border border-solid d-theme-border-grey-light rounded" v-if="isFilterActive">
      <vs-row id="globalFilterHeader" vs-type="flex" vs-w="12" class="mb-3">
        <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
          <span class="text-dark weight-600 text-small">Filtreler</span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
          <feather-icon icon="XIcon" @click.stop="isFilterActive = false" class="cursor-pointer text-danger" />
        </vs-col>
      </vs-row>
      <vs-row id="globalFilterContent" vs-type="flex" vs-w="12" class="flex-wrap items-end">
        <vs-col vs-w="4" vs-sm="12" class="px-1 py-1">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">Zayiat ID</span>
          <input
            type="number"
            v-model="filters.lossId"
            class="w-full vs-inputx vs-input--input normal"
            placeholder="Zayiat ID ile ara..."
            @keyup.enter="applyFilters"
          />
        </vs-col>
        <vs-col v-if="showBranchFilter" vs-w="4" vs-sm="12" class="px-1 py-1">
          <span class="text-secondary2 text-xsmall ml-1 weight-600">Şube</span>
          <v-select
            v-model="filters.branch"
            :options="branches"
            label="name"
            :reduce="b => b"
            placeholder="Tüm şubeler"
            class="w-full"
            :clearable="true"
          />
        </vs-col>
        <vs-col vs-w="4" vs-sm="12" class="px-1 py-1">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-w="6" class="pr-1">
              <span class="text-secondary2 text-xsmall weight-600">Baş. Tarih</span>
              <datepicker placeholder="Başlangıç" class="w-full filterStartDate" :language="turkish" :format="format" v-model="filters.dateRange.startDate" />
            </vs-col>
            <vs-col vs-w="6">
              <span class="text-secondary2 text-xsmall weight-600">Bit. Tarih</span>
              <datepicker placeholder="Bitiş" class="w-full filterEndDate" :language="turkish" :format="format" v-model="filters.dateRange.endDate" />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" class="ml-auto" vs-w="4">
          <vs-button @click="clearFilters" icon-pack="feather" icon="icon-rewind" size="small" color="warning" class="mr-2 px-6">
            Temizle
          </vs-button>
          <vs-button @click="applyFilters" icon-pack="feather" icon="icon-search" color="primary" size="small" class="px-6">
            Ara
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-row>

    <!-- Standard Header / Buttons Bar -->
    <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between" class="mb-3 px-2">
      <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-align="center">
        <vs-row vs-type="flex" vs-w="12" vs-align="center">
          <vs-col vs-type="flex" class="w-auto">
            <vx-tooltip text="Detaylı Filtreleme" position="top">
              <vs-button
                @click="isFilterActive = !isFilterActive"
                class="panel-action text-warning xlarge-button panel-action-box-shadow mr-2"
                color="transparent"
                icon-pack="pickicon"
                icon="icon-pick-filter"
              />
            </vx-tooltip>
          </vs-col>
          <vs-col vs-type="flex" class="w-auto" v-if="filters.lossId || filters.branch">
            <vs-chip closable @click="clearFilters">
              Aktif filtreleri temizle
            </vs-chip>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-tabs v-model="activeTab">
      <vs-tab label="Aktif Zayiatlar" @click="activeTab = 0">
        <div class="mt-4">
          <vs-table :data="losses" stripe>
            <template slot="thead">
              <vs-th class="w-1/12"><span class="bold text-primary">ID</span></vs-th>
              <vs-th class="w-2/12"><span class="bold text-primary">Tarih</span></vs-th>
              <vs-th class="w-3/12"><span class="bold text-primary">Şube</span></vs-th>
              <vs-th class="w-2/12"><span class="bold text-primary">Personel</span></vs-th>
              <vs-th class="w-2/12"><span class="bold text-primary">Sebep</span></vs-th>
              <vs-th class="w-1/12"><span class="bold text-primary">Tutar</span></vs-th>
              <vs-th class="w-1/12" v-if="canDeleteLoss"><span class="bold text-primary">İşlem</span></vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="row.id" v-for="row in data">
                <vs-td class="w-1/12">{{ row.id }}</vs-td>
                <vs-td class="w-2/12">{{ row.date }} {{ row.time }}</vs-td>
                <vs-td class="w-3/12">{{ row.branch ? row.branch.name : '-' }}</vs-td>
                <vs-td class="w-2/12">{{ row.user ? row.user.name : '-' }}</vs-td>
                <vs-td class="w-2/12">{{ row.lossReason ? row.lossReason.name : '-' }}</vs-td>
                <vs-td class="w-1/12">{{ formatPrice(row) }}</vs-td>
                <vs-td class="w-1/12" v-if="canDeleteLoss">
                  <vx-tooltip
                    v-if="row.canDelete === false"
                    :text="row.deleteBlockedReason || 'Son stok sayımı öncesi kayıt silinemez.'"
                  >
                    <vs-button size="small" color="danger" type="border" class="loss-delete-btn" disabled>
                      Sil
                    </vs-button>
                  </vx-tooltip>
                  <vs-button
                    v-else
                    size="small"
                    color="danger"
                    type="border"
                    class="loss-delete-btn"
                    @click="openDeleteModal(row)"
                  >
                    Sil
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pagination-default
            class="mt-4"
            :totalLenght="lossPageCount"
            @currentPage="onLossPageChange"
          />
        </div>
      </vs-tab>
      <vs-tab label="Silme Kayıtları" @click="activeTab = 1">
        <div class="mt-4">
          <vs-table :data="deleteLogs" stripe>
            <template slot="thead">
              <vs-th class="w-1/12"><span class="bold text-primary">Zayiat ID</span></vs-th>
              <vs-th class="w-2/12"><span class="bold text-primary">Şube</span></vs-th>
              <vs-th class="w-2/12"><span class="bold text-primary">Hammadde</span></vs-th>
              <vs-th class="w-1/12"><span class="bold text-primary">Miktar</span></vs-th>
              <vs-th class="w-2/12"><span class="bold text-primary">Stok Önce / Sonra</span></vs-th>
              <vs-th class="w-1/12"><span class="bold text-primary">Silen</span></vs-th>
              <vs-th class="w-2/12"><span class="bold text-primary">Sebep</span></vs-th>
              <vs-th class="w-1/12"><span class="bold text-primary">Tarih</span></vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="row.id" v-for="row in data">
                <vs-td class="w-1/12">{{ row.lossId }}</vs-td>
                <vs-td class="w-2/12">{{ row.branch ? row.branch.name : '-' }}</vs-td>
                <vs-td class="w-2/12">{{ row.rawMaterialName || '-' }}</vs-td>
                <vs-td class="w-1/12">{{ row.deletedQuantity }} {{ row.unitName }}</vs-td>
                <vs-td class="w-2/12">{{ row.stockQuantityBefore }} → {{ row.stockQuantityAfter }}</vs-td>
                <vs-td class="w-1/12">{{ row.deletedByUser ? row.deletedByUser.name : '-' }}</vs-td>
                <vs-td class="w-2/12">{{ row.deleteReason }}</vs-td>
                <vs-td class="w-1/12">{{ row.deletedAt }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pagination-default
            class="mt-4"
            :totalLenght="logPageCount"
            @currentPage="onLogPageChange"
          />
        </div>
      </vs-tab>
    </vs-tabs>

    <vs-popup title="Zayiat Sil" class="loss-delete-popup" :active.sync="deleteModalActive">
      <div v-if="selectedLoss">
        <p class="mb-2"><strong>ID:</strong> {{ selectedLoss.id }}</p>
        <p class="mb-2"><strong>Şube:</strong> {{ selectedLoss.branch ? selectedLoss.branch.name : '-' }}</p>
        <p class="mb-2"><strong>Tutar:</strong> {{ formatPrice(selectedLoss) }}</p>
        <vs-alert color="warning" class="mb-4" active="true">
          Bu işlem geri alınamaz. Stok ters hareketle iade edilir ve ilgili gider pasifleştirilir.
        </vs-alert>
        <vs-textarea v-model="deleteReason" label="Silme sebebi (zorunlu)" class="mb-4" />
        <div class="flex justify-end">
          <vs-button color="primary" type="border" class="mr-2 loss-cancel-btn" @click="deleteModalActive = false">İptal</vs-button>
          <vs-button color="danger" :disabled="deleting" @click="confirmDelete">Sil</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import PaginationDefault from "../PaginationDefault";
import { getLossList, getLossListForDealer, getLossById, deleteLoss, getLossDeleteLogs } from "@/api/Loss.js";
import { getBranchNameList } from "@/api/User";
import Datepicker from "vuejs-datepicker";
import { tr } from "vuejs-datepicker/dist/locale";

export default {
  components: { PaginationDefault, Datepicker },
  data() {
    return {
      activeTab: 0,
      isFilterActive: false,
      losses: [],
      deleteLogs: [],
      branches: [],
      turkish: tr,
      format: "dd.MM.yyyy",
      filters: {
        lossId: null,
        branch: null,
        dateRange: {
          startDate: this.$now.date(),
          endDate: this.$now.date()
        }
      },
      lossPageIndex: 0,
      logPageIndex: 0,
      itemsPerPage: 10,
      lossTotalCount: 0,
      logTotalCount: 0,
      deleteModalActive: false,
      selectedLoss: null,
      deleteReason: "",
      deleting: false
    };
  },
  computed: {
    canDeleteLoss() {
      return this.$canDeleteLoss();
    },
    showBranchFilter() {
      return this.$isCenterBranch() || this.$isRegionalCenterBranch();
    },
    lossPageCount() {
      return Math.max(1, Math.ceil(this.lossTotalCount / this.itemsPerPage));
    },
    logPageCount() {
      return Math.max(1, Math.ceil(this.logTotalCount / this.itemsPerPage));
    }
  },
  mounted() {
    if (this.showBranchFilter) {
      this.loadBranches();
    }
    this.fetchLosses();
    this.fetchDeleteLogs();
  },
  methods: {
    loadBranches() {
      getBranchNameList().then((res) => {
        if (res && res.status === 200) {
          this.branches = res.data || [];
        }
      });
    },
    buildListPayload() {
      const payload = {
        sortBy: "Id",
        sortDirection: "desc",
        pageIndex: this.lossPageIndex,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate: this.filters.dateRange.startDate,
          endDate: this.filters.dateRange.endDate
        }
      };
      if (this.filters.lossId) {
        payload.lossId = parseInt(this.filters.lossId, 10);
      }
      if (this.filters.branch && this.filters.branch.id > 0) {
        payload.branch = this.filters.branch;
      }
      return payload;
    },
    fetchLosses() {
      const payload = this.buildListPayload();
      const request = this.$isRegionalCenterBranch()
        ? getLossListForDealer(payload)
        : getLossList(payload);

      request.then((res) => {
        const data = res.data.pageData || res.data.PageData || res.data;
        this.losses = data.losses || data.Losses || data.items || data.Items || [];
        this.lossTotalCount = data.totalCount || data.TotalCount || 0;
      });
    },
    fetchDeleteLogs() {
      const params = {
        pageIndex: this.logPageIndex,
        pageSize: this.itemsPerPage
      };
      if (this.filters.lossId) {
        params.lossId = parseInt(this.filters.lossId, 10);
      }
      if (this.filters.branch && this.filters.branch.id > 0) {
        params.branch = this.filters.branch;
      }
      if (this.filters.dateRange.startDate) {
        params.startDate = this.filters.dateRange.startDate.toDateString();
      }
      if (this.filters.dateRange.endDate) {
        params.endDate = this.filters.dateRange.endDate.toDateString();
      }
      getLossDeleteLogs(params).then((res) => {
        const data = res.data.pageData || res.data.PageData || res.data;
        this.deleteLogs = data.losses || data.Losses || data.items || data.Items || [];
        this.logTotalCount = data.totalCount || data.TotalCount || 0;
      });
    },
    applyFilters() {
      this.isFilterActive = false;
      this.lossPageIndex = 0;
      this.logPageIndex = 0;
      this.fetchLosses();
      this.fetchDeleteLogs();
    },
    clearFilters() {
      this.isFilterActive = false;
      this.filters.lossId = null;
      this.filters.branch = null;
      this.filters.dateRange.startDate = this.$now.date();
      this.filters.dateRange.endDate = this.$now.date();
      this.applyFilters();
    },
    formatPrice(row) {
      if (!row.entries) return "0";
      const total = row.entries.reduce((sum, e) => sum + (e.price || 0), 0);
      return this.$options.filters && this.$options.filters.currency
        ? this.$options.filters.currency(total)
        : total.toFixed(2);
    },
    onLossPageChange(page) {
      this.lossPageIndex = page - 1;
      this.fetchLosses();
    },
    onLogPageChange(page) {
      this.logPageIndex = page - 1;
      this.fetchDeleteLogs();
    },
    openDeleteModal(row) {
      if (!this.canDeleteLoss || row.canDelete === false) return;
      getLossById(row.id).then((res) => {
        this.selectedLoss = res.data;
        this.deleteReason = "";
        this.deleteModalActive = true;
      });
    },
    confirmDelete() {
      if (!this.canDeleteLoss) return;
      if (!this.deleteReason || !this.deleteReason.trim()) {
        this.$vs.notify({ color: "danger", title: "Hata", text: "Silme sebebi zorunludur." });
        return;
      }
      this.deleting = true;
      deleteLoss({ id: this.selectedLoss.id, reason: this.deleteReason.trim() })
        .then(() => {
          this.$vs.notify({ color: "success", title: "Başarılı", text: "Zayiat silindi." });
          this.deleteModalActive = false;
          this.fetchLosses();
          this.fetchDeleteLogs();
        })
        .catch((err) => {
          const msg = err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0].message
            : "Silme işlemi başarısız.";
          this.$vs.notify({ color: "danger", title: "Hata", text: msg });
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  }
};
</script>

<style scoped>
#lossDeletionPage .loss-filter-btn.vs-button-primary:not(.vs-button-line) {
  color: #fff !important;
}

#lossDeletionPage .loss-filter-btn:not(.vs-button-border) ::v-deep .vs-button--text {
  color: #fff !important;
}

#lossDeletionPage .loss-filter-btn:not(.vs-button-border):hover ::v-deep .vs-button--text {
  color: #fff !important;
}

#lossDeletionPage .loss-delete-btn.vs-button-border ::v-deep .vs-button--text {
  color: #c62828 !important;
}

#lossDeletionPage .loss-delete-btn.vs-button-border {
  border-color: #c62828 !important;
}

#lossDeletionPage .loss-delete-btn.vs-button-border:hover ::v-deep .vs-button--text {
  color: #7f1010 !important;
}

#lossDeletionPage .loss-delete-btn.vs-button-border.vs-button--disabled ::v-deep .vs-button--text {
  color: #9e9e9e !important;
}

#lossDeletionPage .loss-cancel-btn.vs-button-border ::v-deep .vs-button--text {
  color: rgba(var(--vs-primary), 1) !important;
}

#lossDeletionPage .loss-cancel-btn.vs-button-border {
  border-color: rgba(var(--vs-primary), 1) !important;
}

#lossDeletionPage .loss-cancel-btn.vs-button-border:hover ::v-deep .vs-button--text {
  color: rgba(var(--vs-primary), 0.85) !important;
}
</style>

<style>
.loss-delete-popup .loss-cancel-btn.vs-button-border {
  border-color: rgba(var(--vs-primary), 1) !important;
}

.loss-delete-popup .loss-cancel-btn .vs-button--text {
  color: rgba(var(--vs-primary), 1) !important;
}

.loss-delete-popup .loss-cancel-btn:hover .vs-button--text {
  color: rgba(var(--vs-primary), 0.85) !important;
}
</style>
